/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ActionNameEnum = (typeof ActionNameEnum)[keyof typeof ActionNameEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionNameEnum = {
  book_now_requester: 'book_now_requester',
  book_now_provider: 'book_now_provider',
  accept_request: 'accept_request',
  accept_request_and_pay: 'accept_request_and_pay',
  modify_request: 'modify_request',
  cancel_request: 'cancel_request',
  decline_request: 'decline_request',
  modify_booking: 'modify_booking',
  cancel_booking: 'cancel_booking',
  accept_modifications: 'accept_modifications',
  payment_intent: 'payment_intent',
  accept_modifications_and_pay: 'accept_modifications_and_pay',
  accept_modifications_without_notification: 'accept_modifications_without_notification',
  accept_without_notification_and_pay: 'accept_without_notification_and_pay',
  decline_modifications: 'decline_modifications',
  open_review_feedback_page: 'open_review_feedback_page',
  archive: 'archive',
  unarchive: 'unarchive',
  open_details_page: 'open_details_page',
  open_profile_page: 'open_profile_page',
  open_payment_history_page: 'open_payment_history_page',
  open_pet_profile_page: 'open_pet_profile_page',
  open_care_instructions_page: 'open_care_instructions_page',
  open_report_page: 'open_report_page',
  open_booking_details_page: 'open_booking_details_page',
  open_availability_page: 'open_availability_page',
  open_itinerary_pdf: 'open_itinerary_pdf',
  open_rebook_page: 'open_rebook_page',
  open_receive_payments_page: 'open_receive_payments_page',
  call_customer_support: 'call_customer_support',
  call_other_person: 'call_other_person',
  video_call: 'video_call',
  open_vet_info_modal: 'open_vet_info_modal',
  open_meet_and_greet_modal: 'open_meet_and_greet_modal',
  open_archive_modal: 'open_archive_modal',
  open_gallery_modal: 'open_gallery_modal',
  open_trust_and_safety_modal: 'open_trust_and_safety_modal',
  open_maps: 'open_maps',
  open_price_info_modal: 'open_price_info_modal',
  open_modify_booking_modal: 'open_modify_booking_modal',
  open_service_fee_info_page: 'open_service_fee_info_page',
  open_get_more_credits_page: 'open_get_more_credits_page',
  propose_meet_and_greet: 'propose_meet_and_greet',
  modify_meet_and_greet: 'modify_meet_and_greet',
  acknowledge_tips_for_safe_stay: 'acknowledge_tips_for_safe_stay',
  open_lock_rates_modal: 'open_lock_rates_modal',
  open_payout_modal: 'open_payout_modal',
  open_pay_error_modal: 'open_pay_error_modal',
  open_credit_add_on_modal: 'open_credit_add_on_modal',
  open_reccuring_service_date_passed_modal: 'open_reccuring_service_date_passed_modal',
  lock_rates: 'lock_rates',
  change_default_payment_method: 'change_default_payment_method',
  start_rover_card: 'start_rover_card',
  open_rover_card: 'open_rover_card',
  open_unified_checkout: 'open_unified_checkout',
  modify_schedule_requester: 'modify_schedule_requester',
} as const;
